import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstadoRevisionCargaFamiliarDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstadoRevisionCargaFamiliarService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getEstadoRevisionCargaFamiliarService(): Observable<BodyListResponse<EstadoRevisionCargaFamiliarDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionCargaFamiliarDTO>>(API_URL + '/api/v1/estadoRevisionCargaFamiliar/todos');
  }

  guardarEstadoRevisionCargaFamiliarService(estadoRevisionCargaFamiliarDTO: EstadoRevisionCargaFamiliarDTO): Observable<EstadoRevisionCargaFamiliarDTO> {
    return this.http.post<EstadoRevisionCargaFamiliarDTO>(API_URL + '/api/v1/estadoRevisionCargaFamiliar', estadoRevisionCargaFamiliarDTO);
  }

  getEstadoRevisionCargaFamiliarPorCodigoEstadoRevisionCargaFamiliarService(codigoEstadoRevisionCargaFamiliar: string): Observable<BodyResponse<EstadoRevisionCargaFamiliarDTO>> {
    return this.http.get<BodyResponse<EstadoRevisionCargaFamiliarDTO>>(API_URL + '/api/v1/estadoRevisionCargaFamiliar/' + codigoEstadoRevisionCargaFamiliar);
  }

  getEstadoRevisionCargaFamiliarPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EstadoRevisionCargaFamiliarDTO>> {
      return this.http.get<BodyListResponse<EstadoRevisionCargaFamiliarDTO>>(API_URL + '/api/v1/estadoRevisionCargaFamiliar/persona/' + codigoPersona);
    }
}
